import React from 'react'
import './index.css'
import CarouselChampions from './components/CarouselChampions'
import { useGetChampionsTeams } from './hooks/useGetChampionsTeams'
import { secureUrl } from '../../utils/sortArray/secureUrl'


const ChampionsScreen = ()=>{
    const { championsFromTournament, tournamentInfo } = useGetChampionsTeams()

    return(<div className='container-champions-carousel'>
        <div className='subcontainer-champions-carousel'>
                    <div className='container-title-carousel-champion'>
                    <img src={secureUrl(tournamentInfo?.imgPicture)} />
                    <h1>Campeones del {tournamentInfo?.name?.replace(/\d/g, '')}</h1>
        </div>
        <CarouselChampions tournament={tournamentInfo} championsFromTournament={championsFromTournament} />
        </div>
    </div>)
}

export default ChampionsScreen